export class EmployeeUserSearchDataModel {
    constructor() {
        this.columnFilters = [];
    }
}
export default class EEmployeeUserSearchData extends EmployeeUserSearchDataModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
